<template>
  <v-row class="ma-0 pa-0">
    <v-col class="pa-0">
      <search-date-picker ref="datePickerStart"
                          v-model="internalValue.startDate"
                          :label="labelForStart"
                          :type="type"
                          :disable="disable"
                          :clear-btn="clearBtn"
      />
    </v-col>
    <v-col class="pa-0 ml-3">
      <search-date-picker ref="datePickerEnd"
                          v-model="internalValue.endDate"
                          :label="labelForEnd"
                          :type="type"
                          :disable="disable"
                          :clear-btn="clearBtn"
      />
    </v-col>
  </v-row>
</template>

<script>
import SearchDatePicker from "@/components/input/SearchDatePicker";
import CoreDate from "@/components/input/CoreDate";

const BIAS_START = 'start';
const BIAS_END = 'end';

export default {
  name: "SearchDateRangePicker",
  components: {SearchDatePicker},
  mixins: [CoreDate],
  props: {
    labelForStart: {
      type: String,
      default() {
        return this.$translate("시작일");
      },
    },
    labelForEnd: {
      type: String,
      default() {
        return this.$translate("종료일");
      },
    },
    type: {
      type: String,
      default: 'date'
    },
    disable: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default: undefined,
    },
    endDate: {
      type: String,
      default: undefined,
    },
    clearBtn: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      internalValue: {
        startDate: undefined,
        endDate: undefined,
      },
    }
  },

  computed: {
  },

  watch: {
    startDate: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if(!newValue) return
        this.internalValue.startDate = newValue
      }
    },
    endDate: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if(!newValue) return
        this.internalValue.endDate = newValue
      }
    },

    internalValue: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if(!!newValue.startDate)
          this.internalValue.startDate = this.$parseDate(newValue.startDate).startOf('day').toISO()
        if(!!newValue.endDate)
          this.internalValue.endDate = this.$parseDate(newValue.endDate).endOf('day').toISO()

        if(this.internalValue.startDate > this.internalValue.endDate) {
          alert('날짜범위가 올바르지 않습니다.')
          this.internalValue.startDate = this.$parseDate(this.internalValue.endDate).startOf('day').toISO()
        }

        this.$emit('update:date', this.internalValue)
      }
    }
  },

  mounted() {
  },

  created() {
  },

  methods: {
  },
}
</script>

<style scoped>
</style>
